import { render } from "./ScheduleAgendaItem.vue?vue&type=template&id=c1e8332e&scoped=true"
import script from "./ScheduleAgendaItem.vue?vue&type=script&lang=js"
export * from "./ScheduleAgendaItem.vue?vue&type=script&lang=js"

import "./ScheduleAgendaItem.vue?vue&type=style&index=0&id=c1e8332e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e8332e"]])

export default __exports__